module.exports = __webpack_public_path__ + "static/media/cerc.edef8aa2.png";